import { Box } from "@mui/material"
import { PageCard, PageCardContent } from "components/card"
import React from "react"

export const PromotionDetailKioskHPage = ({ Layout = Box }) => {
  return (
    <Layout aside={<></>}>
      <PageCard>
        <PageCardContent>Promotion Detail Page</PageCardContent>
      </PageCard>
    </Layout>
  )
}
